import { render, staticRenderFns } from "./AccHistory.vue?vue&type=template&id=01d1c788&"
import script from "./AccHistory.vue?vue&type=script&lang=js&"
export * from "./AccHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports